import { render, staticRenderFns } from "./pdp-text-image.vue?vue&type=template&id=b65e9b52"
import script from "./pdp-text-image.vue?vue&type=script&lang=js"
export * from "./pdp-text-image.vue?vue&type=script&lang=js"
import style0 from "./pdp-text-image.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports